module.exports = __webpack_public_path__ + "img/monitorError.fb76970c.png";